import React from 'react'

const PdfIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.99787 9V1H19.5L23 4.5V23H4M18 1V6H23M16.5 19V12H20.5M16.5 15.5H19.5M3 12H3.25H4.5C6.5 12 6.75 13.25 6.75 14C6.75 14.75 6.5 16 4.5 16H3.25V18H3V12ZM9.5 18V12C9.5 12 10.4474 12 11.2053 12C12.3421 12 13.5 12.5 13.5 15C13.5 17.5 12.3421 18 11.2053 18C10.4474 18 9.5 18 9.5 18Z" stroke="#757575"/>
</svg>

  )
}

export default PdfIcon